export default __webpack_public_path__ + "static/partner1-0744c38cfd96ceba28bab98ba1bdfcb7.webp";